module.exports = __webpack_public_path__ + "media/images/icons/twotone/project-404271f8ffe7b99ab6341fec59727983.svg";